<label class="hf-radio">
  <span
    class="hf-radio__wrapper"
    [ngClass]="{
    outer_layer: outerLayer,
    disabled: isDisabled
  }"
  >
    <input
      #radioInput
      type="radio"
      class="hf-radio__input"
      [name]="name"
      [value]="value"
      [checked]="checked"
      [disabled]="disabled"
      [attr.aria-describedby]="ariaDescribedBy || null"
      (blur)="onTouched()"
      (change)="handleChange()"
    />
    <span class="hf-radio__control" aria-hidden="true"></span>
    <div class="text_grouping">
      <span class="hf-radio__label" *ngIf="label">{{ label }}</span>
      <span class="hf-radio__description" *ngIf="description">{{ description }}</span>
    </div>
  </span>
</label>
